import styled from "styled-components";
import { BREAKPOINTS } from "../../../../../app/appConstants.js";

export const DepositQRCodeStyled = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    padding: 0 32px;
    overflow-y: auto;
    
    @media(max-width: ${BREAKPOINTS.large}px) {
        display: block;
        padding: 0 16px 24px;
    }
`;
export const DepositQRCodeBackStyled = styled.div`
    margin: 32px 32px 16px 32px;

    > div {
        font-weight: bold;
        cursor: pointer;
    }
    
    svg {
        fill: var(--color-secondary);
    }
    
    @media(max-width: ${BREAKPOINTS.large}px) {
        margin: 16px;
        
        svg {
            fill: var(--color-white-60);
        }
    }
`;
export const DepositQRCodeLeftStyled = styled.div`
    flex: 1 0 30%;

    > * {
        width: 100%;
    }

    margin-right: 16px;

    @media(max-width: ${BREAKPOINTS.large}px) {
        margin-right: 0;
        margin-bottom: 16px;
    }
`;

export const DepositQRCodeRightStyled = styled.div`
    flex: 2 1 60%;
`;

export const DepositQRCodeNextStyled = styled.div`
    background: var(--color-surface-secondary);
    border-radius: 4px;
    height: 250px;
    padding: 16px;
    margin-bottom: 16px;

    svg {
        fill: var(--icon-primary-color);
    }

    p.bordered {
        display: block;
        border: 1px solid var(--color-main);
        border-radius: 4px;
        padding: 12px;
    }
    
    p.center {
        display: block;
        text-align: center;
        font-weight: 600;
        color: var(--color-secondary);
    }
`;

export const DepositQRCodeSummaryStyled = styled.div`
    background: var(--color-main);
    border-radius: 4px;
    padding: 0 16px;
    line-height: 54px;
    color: var(--color-secondary);

    .amount {
        text-align: right;
        color: #FFFFFF;
    }
`;

export const DepositQRCodeSummaryRowStyled = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    
    > * {
        flex: 1 0 auto;
    }
    
    .color-white {
        color: var(--color-white);
    }
    
    &:not(:last-child) {
        border-bottom: 1px solid var(--color-surface);
    }
`;

export const DepositQRCodeImageStyled = styled.div`
    text-align: center;
    background: var(--color-white);
    margin-bottom: 16px;
    border-radius: 4px;
    height: 250px;

    > img {
        width: 250px;
        height: 250px;
        border-radius: 4px;
    }
`;
